import { useEffect } from 'react';
import Footer from './components/common/Footer';
import { Box } from '@mui/material';

const termly_resource_blocker_url = process.env.REACT_APP_TERMLY_RESOURCE_BLOCKER;

export default function Copyright() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = termly_resource_blocker_url;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <Box
        sx={{
          minHeight: '30px',
          position: 'relative',
        }}
      >
        <Footer />
      </Box>
    </>
  );
}
